// Module-level flag (tab-scoped, doesn't affect localStorage or other tabs)
let ignoreImpersonation = false;

export function setIgnoreImpersonation(ignore: boolean): void {
  ignoreImpersonation = ignore;
}

export function shouldIgnoreImpersonation(): boolean {
  return ignoreImpersonation;
}
